import { defineComponent, onBeforeMount, ref } from 'vue'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import { useField, useForm } from 'vee-validate'
import Select from '@/components/select'
import AddressDropdown from './components/AddressDropdown/AddressDropdown'
import Preloader from '@/components/preloader/preloader.vue'

export default defineComponent({
  props: {
    isCompany: {
      type: Boolean,
      default: false
    },
    deliveryMethod: {
      type: String,
      default: () => ''
    },
    onSendSuccess: {
      type: Function,
      default: (value: boolean) => value
    }
  },
  setup (props) {
    yup.setLocale(ru)

    const preloader = ref(false)

    const regions = ref([])
    const regionAlias = ref([])
    const cities = ref([])
    const cityAlias = ref('')
    const addresses = ref([])

    const deliveryCompanies = ref([])
    const typePayment = ref({})
    const typeDelivery = ref({})
    const typesPayment = ref(
      [
        {
          value: 'upon_receipt',
          text: 'Оплачу при получении'
        },
        {
          value: 'check',
          text: 'Включить в счет'
        }
      ]
    )
    const typesDelivery = ref(
      [
        {
          value: 'to_address',
          text: 'Доставка до адреса'
        },
        {
          value: 'to_terminal',
          text: 'Доставка до терминала транспортной компании'
        }
      ]
    )

    onBeforeMount(async () => {
      if (props.isCompany) {
        typePayment.value = typesPayment.value[0]
      } else {
        typeDelivery.value = typesDelivery.value[0]
      }

      deliveryCompanies.value = (await axios.get(`${host}/api/v1/delivery-companies`)).data.items

      if (deliveryCompanies.value) {
        // @ts-ignore
        deliveryCompany.value = deliveryCompanies.value[0].title
      }
    })

    async function getAddressDadata (url: string, type: string, value: string) {
      return (await axios.get(`${host}${url}&query=${value}`)).data.items
    }

    async function getRegions (e: Event) {
      const url = '/api/v1/get-address?from_bound[value]=region&to_bound[value]=region'
      regions.value = await getAddressDadata(url, 'region', (e.target as HTMLInputElement).value)
    }

    function selectRegion (item: Record<string, string>) {
      region.value = item.value
      // @ts-ignore
      regionAlias.value = item.data.region
      regions.value = []
    }

    async function getCities (e: Event) {
      const url = `/api/v1/get-address?locations[0][region]=${regionAlias.value}&from_bound[value]=city&to_bound[value]=settlement&restrict_value=true`
      cities.value = await getAddressDadata(url, 'city', (e.target as HTMLInputElement).value)
    }

    function selectCity (item: Record<string, string>) {
      city.value = item.value
      // @ts-ignore
      cityAlias.value = item.data.city
      cities.value = []
    }

    async function getAddresses (e: Event) {
      const url = `/api/v1/get-address?locations[0][city]=${cityAlias.value}&locations[0][region]=${regionAlias.value}&from_bound[value]=street&restrict_value=true`
      addresses.value = await getAddressDadata(url, 'address', (e.target as HTMLInputElement).value)
    }

    function selectAddress (item: Record<string, string>) {
      address.value = item.value
      addresses.value = []
    }

    function selectPayment (pay: any) {
      payment.value = pay.value
    }

    function selectTypeDelivery (del: any) {
      delivery.value = del.value
    }

    const schema = yup.object().shape(
      {
        payment: yup.string().required(),
        delivery: yup.string().required(),
        region: yup.string().required(),
        city: yup.string().required(),
        address: yup.string().required()
      }
    )

    type FormInputs = {
      payment: string
      delivery: string,
      region: string,
      city: string,
      address: string,
      deliveryCompany: string
    }

    // @ts-ignore
    const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })

    const { value: payment, errorMessage: paymentError } = useField<string | undefined>('payment')
    const { value: delivery, errorMessage: deliveryError } = useField<string | undefined>('delivery')
    const { value: region, errorMessage: regionError } = useField<string | undefined>('region')
    const { value: city, errorMessage: cityError } = useField<string | undefined>('city')
    const { value: address, errorMessage: addressError } = useField<string | undefined>('address')
    const { value: deliveryCompany, errorMessage: deliveryCompanyError } = useField<string | undefined>('deliveryCompany')

    const onSubmit = handleSubmit(async (values) => {
      preloader.value = true

      const url = '/api/v1/client/delivery-edit'
      const data = {
        isCompany: props.isCompany,
        deliveryMethod: props.deliveryMethod,
        ...values
      }

      try {
        const response = (await axios.post(`${host}${url}`, data))
        preloader.value = false
        props.onSendSuccess(true)
      } catch (e) {
        preloader.value = false
        props.onSendSuccess(false)
      }
      // TODO дописать запрос на отправку формы
    })

    return () => {
      return (
        <form onSubmit={values => onSubmit(values)}>
          <div class="steps">
            <div class="step">
              <p>1. Тип доставки</p>
              {typesDelivery.value.map((delivery, index) => (
                <div class="step-input">
                  <input
                    type="radio"
                    name="delivery"
                    id={delivery.value}
                    value={delivery.text}
                    checked={delivery.value === typeDelivery.value}
                    onClick={() => selectTypeDelivery(delivery)}
                  />
                  <label for={delivery.value}>
                    {delivery.text}
                  </label>
                </div>
              ))}
              <span class="error-message">{deliveryError.value}</span>
            </div>
            <div class="step">
              <p>2. Регион доставки</p>
              <div class="step-input">
                <input
                  type="text"
                  onFocus={e => getRegions(e)}
                  onFocusout={() => setTimeout(() => { regions.value = [] }, 50)}
                  onInput={e => getRegions(e)}
                  v-model={region.value}
                />
                {regions.value
                  ? (<AddressDropdown items={regions.value} onSelect={(item: any) => { selectRegion(item) }}/>)
                  : null
                }
              </div>
              <span class="error-message">{regionError.value}</span>
            </div>
            <div class="step">
              <p>3. Населенный пункт</p>
              <div class="step-input">
                <input
                  type="text"
                  onFocus={e => getCities(e)}
                  onFocusout={() => setTimeout(() => { cities.value = [] }, 50)}
                  onInput={e => getCities(e)}
                  disabled={!region.value}
                  v-model={city.value}
                />
                {cities.value
                  ? (<AddressDropdown items={cities.value} onSelect={(e: any) => { selectCity(e) }}/>)
                  : null
                }
              </div>
              <span class="error-message">{cityError.value}</span>
            </div>
            <div class="step">
              <p>4. Адрес доставки</p>
              <div class="step-input">
                <input
                  type="text"
                  onFocus={e => getAddresses(e)}
                  onFocusout={() => setTimeout(() => { addresses.value = [] }, 50)}
                  onInput={e => getAddresses(e)}
                  disabled={!region.value || !city.value}
                  v-model={address.value}
                />
                {addresses.value
                  ? (<AddressDropdown items={addresses.value} onSelect={(e: any) => { selectAddress(e) }}/>)
                  : null
                }
              </div>
              <span class="error-message">{addressError.value}</span>
            </div>
            <div class="step">
              <p>5. Название транспортной компании</p>
              {deliveryCompanies.value.length > 0 ? (
                <Select
                  class="orders-filters-select"
                  options={deliveryCompanies.value}
                  onSelectChange={ (value: any) => { deliveryCompany.value = value.title }}
                  value={deliveryCompany.value}
                />
              ) : null }
            </div>
          </div>
          {preloader.value
            ? (<Preloader style="position: relative; margin: 50px auto; top: -10px;"/>)
            : (<button>Завершить подтверждение</button>)
          }
        </form>
      )
    }
  }
})